export default {
  risk: {
    serviceTitle: '风控服务',
    designTitle: '方案设计',
    abilityTitle: '冠晨能力',
    customerTitle: '客户效益',
    serviceDesc: 'R&C Services',
    designDesc: 'Scheme Design',
    abilityDesc: 'YUSHI Ability',
    customerDesc: 'Customer Benefit',
    customerDesc2: '海外信息产品风控服务产品：灵鹰风控',
    menuTitle1: '海量征信数据',
    menuTitle2: '系统亮点',
    menuTitle3: '自动化风控审核',
    menuTitle4: '海量征信数据',
    menuTitle5: '系统亮点',
    menuTitle6: '自动化风控审核',
    menuContent1: '数十家风控数据提供商接入，接收 市场信用反馈，智能识别欺诈用户。',
    menuContent2: '拥有海外信贷市场10000+个风控 模型特征变量，支持全自动审核， 准实时反馈结果。',
    menuContent3: '机审＋人审，整合征信报告、 设备信息、用户行为、社交关联等 数据，灵活定制风控策略。',
    menuContent4: '数十家风控数据提供商接入，接收 市场信用反馈，智能识别欺诈用户。',
    menuContent5: '拥有海外信贷市场10000+个风控 模型特征变量，支持全自动审核， 准实时反馈结果。',
    menuContent6: '机审＋人审，整合征信报告、 设备信息、用户行为、社交关联等 数据，灵活定制风控策略。'
  },
  home: {
    guanchen: '冠晨网络',
    home: '首页',
    riskTitle: '大数据风控',
    saasTitle: 'SaaS服务',
    businessTitle: '业务联运',
    riskDesc: '通过大数据和机器学习等金融科技构建风控解决方案，为客户资产提供保驾护航',
    saasDesc: '经致力于全球市场金融系统后台开发，提供海外信贷系统后台开发定制、运营维护、数据接入等服务',
    businessDesc: '拥有专业的落地咨询团队',
    sass1Title: '灵活部署',
    sass2Title: '系统亮点',
    sass3Title: '流量对接',
    sass1Desc: '系统独立部署， 高度可定制化，搭建产品、研发、 风险专家等基础模块， 快速确认业务需求',
    saas2Desc: '数据源多元化， 全面支持自定义风控规则及策略 支持新老用户跑测不同风控策略',
    saas3Desc: '自研数据统计分析工具及 提供标准化对接流量平台接口'
  },
  contact: {
    team: 'TEAM & ADVISORS',
    title: '关于我们',
    titleDesc: 'Contact Us',
    company: '广州冠晨信息科技有限公司',
    introduct: `冠晨网络是专业的海外科技金融解决方案服务商，专注于大数据风控智能分
    析与决策，致力于建设智能风控、金融大数据等金融科技产品，为东南亚、印度、
    非洲、南美等海外互联网金融行业提供全生命周期的产品和服务。冠晨网络高管
    团队主要来自阿里、百度、腾讯等海内外知名企业，在技术研发、AI智能、大
    数据风控以及产品运营领域具有丰富实战经验和优势，同时在海外还有专业的本
    地催收团队，已成长为行业头部企业。目前公司已完成信贷业务管理SAAS平台
    "BlueSky"与线上金融风控平台"灵鹰风控服务"等板块的部署，形成了完整的全
    生命周期的产品与服务。
    从产品业务、交互、数据、风控、运营等角度打造出符合海外本地用户体验
    及具备传播性的信贷app产品。同时研究出一套为贷超服务商提供全方位赋能的
    解决方案，让贷超服务商专心于流量运营，提供信贷、风控全流程解决方案及流
    量精准决策分发方案。在贷前审核、注册登录、借款提现、贷中审查、贷后管理
    等多场景都有完善的策略解决方案。在贷前审核环节，对客户准入、黑名单、信
    息核验、关联风险、设备风险、多头借贷、联系人风险、用户行为等多个维度设
    计策略，在贷款申请的环节对借款人进行全方位的风险评估。冠晨网络可以提供
    全业务流程解决方案，从流量获客、风控审核到贷后管理，全程为客户保驾护航。`
  },
  saas: {
    saasTitle: 'SaaS服务',
    designTitle: '方案设计',
    abilityTitle: '冠晨能力',
    customerTitle: '客户效益',
    saasDesc: 'SaaS Services',
    designDesc: 'Scheme Design',
    abilityDesc: 'YUSHI Ability',
    customerDesc1: 'Customer Benefit',
    customerDesc2: '为客户提供：集功能化、可操作化、集成化、模块化、数据化于一体的后台数据管理信息系统。',
    menuTitle1: '本地化定制',
    menuTitle2: '系统亮点',
    menuTitle3: '自研风控系统',
    menuTitle4: '自研用户行为采集',
    menuTitle5: 'API接口服务',
    menuTitle6: '成熟信贷后台系统',
    menuContent1: '系统独立部署，高度可定制化。拥有专业产品研发团队，可支持本地化APP定制开发，交互设计，UI定制。',
    menuContent2: '接入AI智能检测技术系列，电子、人脸识别和活体测试等技术。保证合规要求，提升进审转化。',
    menuContent3: '输出风控技术，利用大数据和机器学习等金融科技构建风控系统。已推出风控明星产品-灵鹰风控，积累实盘数据表现。',
    menuContent4: '输出的智能策略、模型分。经过百万级用户数据的验证，支持策略模型的快速迭代。',
    menuContent5: '自研SDK嵌入合作产品，采集用户设备信息用于做反欺诈类风控服务。数据隔离，保障隐私合规。',
    menuContent6: 'SAAS信贷后台系统（支持中、英），包括信审、财务、反欺诈、风控、催收等。'
  },
  footer: {
    company: '公司简介',
    email: '联系邮箱：guanchen@outlook.com',
    companyName: '公司名称：广州冠晨网络有限公司',
    address: '公司地址：广州市天河区车陂路113号东宏国际广场1902',
    owner: 'Copyright©2002-2022冠晨网络官网版权所有'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js